module.exports = __webpack_public_path__ + "img/arrow.18cc12d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/arrow.png
// module id = gDOO
// module chunks = 12